import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "facebook_flat",
  "use": "facebook_flat-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"facebook_flat\"><path fill=\"#FFF\" d=\"M15.967.066C7.15.066 0 7.216 0 16.034c0 7.909 5.757 14.46 13.304 15.728V19.365H9.453v-4.46h3.851v-3.29c0-3.817 2.331-5.897 5.737-5.897 1.63 0 3.032.122 3.439.176v3.989l-2.362.001c-1.851 0-2.208.88-2.208 2.17v2.848h4.417l-.576 4.46H17.91v12.506c7.9-.961 14.025-7.678 14.025-15.839 0-8.814-7.15-15.963-15.968-15.963z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol